<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
            :ref="'sensorCrud'"
            :crudName="$t('Sensors')"
            :newText="$t('Add')+ '  '+$t('New')"
            :table="table"
            :columns="columns"
            :options="options"
            :endPoint="endPoint"
            :enableAdd="true"
            :enableEdit="true"
            :enableDelete="true"
            :enableView="false"
            :enableReset="false"
            :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "sensorTable",
      showMessageImport: false,
      sensorCrud: {},
      pages: [],
      url: "",
      columns: [
        "id",
        "name",
        "event_type_id",
        "actions",
      ],
      tableData: ["id", "name", "event_type_id"],
      optionsOrigin: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "name", "event_type_id"],
        sortable: ["id", "name", "event_type_id"],
        sortIcon: {
          base: "fa",
          up: "fa-sort-up",
          down: "fa-sort-down",
          is: "fa-sort",
        },
        pagination: {
          chunk: 10,
          dropdown: false,
          nav: "scroll"
        },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: this.$t('id'),
          name: this.$t('name'),
          event_type_id: this.$t('Event type'),
          actions: this.$t('action'),
        },

        texts: {
          filterBy: this.$t('Filter'),
          defaultOption: this.$t('Select'),
        },
        listColumns: {},
        templates: {
          event_type_id: function (h, row, index) {
            return row.event_type?.name ?? ''
          },
        },
        requestFunction: function (data) {
          let requestData = {};


          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["eventType"];

          return axios.get(this.url + "?" + query, requestData).catch(
              function (e) {
                this.dispatch("error", e);
              }.bind(this)
          );
        },
      },
      endPoint: "sensors",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  computed: {
    options() {
      const headings = {
        id: this.$t('id'),
        name: this.$t('name'),
        event_type_id: this.$t('Event type'),
        actions: this.$t('action'),
      }

      const texts = {
        filterBy: this.$t('Filter'),
        defaultOption: this.$t('Select'),
      }
      return {
        ...this.optionsOrigin,
        texts,
        headings,
      }

    }

  },
  methods: {

    query: function (query) {
      let columns = {
        id: "id",
        name: "name",
        event_type_id: "eventType[name]",

      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },

  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>
